import getHelper from '../../../services/getHelper';
import type { CommunityPaths } from '../../../../../index';

export default getHelper<CommunityPaths>('/community/paths/map-channels');
